module.exports = __webpack_public_path__ + "img/ok.56bc2b83.svg";